(function () {
    'use strict';

    function documentUploadGroup($compile, $http, workflowProcessingService) {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/documentUploadGroup.html',
            scope: {
                InformationPart: '=informationPart',
                user: '='
            },
            link: function (scope, element) {

                scope.adminMode = false;
                scope.$watch(function () {
                    return workflowProcessingService.adminMode;
                }, function (newValue) {
                    scope.adminMode = newValue;
                });
            }
        };
    }

    documentUploadGroup.$inject = ['$compile', '$http', 'workflowProcessingService'];

    angular.module('ecap.workflow').directive('documentUploadGroup', documentUploadGroup);
})();
